class WindowSvc {
	currentTimeMillis() {
		return Date.now();
	}
}

export const windowSvc = new WindowSvc();
